import UserDashboard from './UserDashboard';

export default function Dashboard({ go, toast }) {
  return <UserDashboard go={go} toast={toast} />;
}
